import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faLink, faLinkSlash, faTriangleExclamation, faVideo, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";
import Badge from "./Badge";
import api from "../../services/api";
import { useToast } from "../ToastProvider";
import { buildItemBlocks, groupLabel } from "./workoutAdminHelpers";
import { useWorkoutAdminContext } from "../../context/WorkoutAdminContext";

// Props removidas em favor de useWorkoutAdminContext() (issue 012,
// docs/07-issues.md) -- mesmo WorkoutAdminContext já usado por StudentsTab.jsx.
export default function StudentAssignmentModal() {
  const {
    selectedStudentAssignment,
    selectedStudentAssignmentId,
    selectedStudent,
    studentAssignmentModalRef,
    closeStudentAssignmentModal,
    assignmentMetaForm,
    setAssignmentMetaForm,
    handleUpdateAssignmentMeta,
    confirmActionRef,
    confirmRemoveAnonAssignmentItem,
    confirmRestorePlanItem,
    groupConflictsAssignment,
    groupSelectModeAssignment,
    setGroupSelectModeAssignment,
    groupSelectedIdsAssignment,
    groupSelectionTypeAssignment,
    handleCancelGroupSelectAssignment,
    handleCreateAssignmentGroupClick,
    handleMoveAssignmentBlock,
    handleUngroupAssignmentBlock,
    openAddAnonItem,
    openAssignmentItemEditor,
    resetFeedback,
    saving,
    setSaving,
    setConfirmLabel,
    setConfirmMessage,
    setOpenStudentAssignmentModal,
    setShowConfirm,
    setStudentAssignments,
    toggleGroupSelectItemAssignment,
  } = useWorkoutAdminContext();
  const toast = useToast();

  return (
    <div className={styles.innerOverlay} onClick={closeStudentAssignmentModal}>
                      <div
                        className={styles.planModal}
                        ref={studentAssignmentModalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="wam-student-assign-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className={styles.planModalHeader}>
                          <div>
                            <h3 id="wam-student-assign-title">Personalização do aluno</h3>
                            <p>{selectedStudent?.name}</p>
                          </div>
                          <button
                            type="button"
                            className={styles.planModalClose}
                            onClick={() => setOpenStudentAssignmentModal(false)}
                            aria-label="Fechar modal"
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>

                        <div style={{ marginBottom: 12, display: "flex", flexDirection: "column", gap: 10 }}>
                          <div className={styles.wamField}>
                            <label>Nome do treino para este aluno <span style={{fontWeight:"normal",color:"var(--text-secondary)"}}>(opcional)</span></label>
                            <input
                              type="text"
                              placeholder={selectedStudentAssignment?.workout_plan?.title || "Nome personalizado"}
                              value={assignmentMetaForm.custom_name}
                              onChange={(e) => setAssignmentMetaForm((p) => ({ ...p, custom_name: e.target.value }))}
                              maxLength={120}
                            />
                          </div>
                          <div className={styles.wamFormGrid}>
                            <div className={styles.wamField}>
                              <label>Sugestão do dia da semana</label>
                              <select
                                value={assignmentMetaForm.day_of_week}
                                onChange={(e) => setAssignmentMetaForm((p) => ({ ...p, day_of_week: e.target.value }))}
                              >
                                <option value="">Sem sugestão</option>
                                <option value="0">Segunda-feira</option>
                                <option value="1">Terça-feira</option>
                                <option value="2">Quarta-feira</option>
                                <option value="3">Quinta-feira</option>
                                <option value="4">Sexta-feira</option>
                                <option value="5">Sábado</option>
                                <option value="6">Domingo</option>
                              </select>
                            </div>

                            <div className={styles.wamField}>
                              <label>&nbsp;</label>
                              <button
                                type="button"
                                className={`${styles.wamBtn} ${styles.primary}`}
                                onClick={handleUpdateAssignmentMeta}
                                disabled={saving}
                              >
                                Salvar preferência
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className={styles.planItemList}>
                          <div className={styles.planItemRow}>
                            <div className={styles.planItemRowMain}>
                              <div className={styles.planItemTitle}>Exercícios personalizados</div>
                              <div className={styles.planItemMeta}><span>Itens específicos deste aluno</span></div>
                            </div>
                            <div className={styles.planItemRowActions}>
                              <button type="button" className={`${styles.wamBtn} ${styles.smallGhost}`} onClick={openAddAnonItem}>
                                Adicionar exercício avulso
                              </button>
                            </div>
                          </div>

                          {(selectedStudentAssignment.items?.length || 0) >= 2 && (
                            <div className={styles.groupSelectBar}>
                              {!groupSelectModeAssignment ? (
                                <button
                                  type="button"
                                  className={`${styles.wamBtn} ${styles.smallGhost}`}
                                  onClick={() => setGroupSelectModeAssignment(true)}
                                >
                                  <FontAwesomeIcon icon={faLayerGroup} /> Agrupar em bi-set
                                </button>
                              ) : (
                                <>
                                  <span className={styles.groupSelectHint} aria-live="polite">
                                    {groupSelectedIdsAssignment.length === 0
                                      ? "Selecione 2+ exercícios pra formar um bi-set/superset"
                                      : `${groupSelectedIdsAssignment.length} selecionado(s)`}
                                  </span>
                                  {groupConflictsAssignment.length > 0 && (
                                    <span className={styles.groupConflictWarning} role="alert">
                                      <FontAwesomeIcon icon={faTriangleExclamation} /> Vai desfazer o grupo com{" "}
                                      {groupConflictsAssignment.map((c) => c.names.join(" + ")).join("; ")}
                                    </span>
                                  )}
                                  <button
                                    type="button"
                                    className={`${styles.wamBtn} ${styles.smallGhost}`}
                                    onClick={handleCreateAssignmentGroupClick}
                                    disabled={groupSelectedIdsAssignment.length < 2 || saving}
                                  >
                                    {groupSelectionTypeAssignment
                                      ? `Agrupar (${groupSelectedIdsAssignment.length}) em ${groupSelectionTypeAssignment.toLowerCase()}`
                                      : "Agrupar"}
                                  </button>
                                  <button
                                    type="button"
                                    className={`${styles.wamBtn} ${styles.smallGhost}`}
                                    onClick={handleCancelGroupSelectAssignment}
                                  >
                                    Cancelar
                                  </button>
                                </>
                              )}
                            </div>
                          )}

                          {(() => {
                            // Mesmo item pode ser o override real (UserWorkoutPlanItem) ou,
                            // pro grupo, o próprio item avulso — não muda a renderização.
                            // Linha inteira clicável em modo seleção (achado #2 da
                            // auditoria UX) — ignora clique vindo do próprio
                            // checkbox pra não alternar 2x.
                            const handleAssignmentRowClick = (item, e) => {
                              if (!groupSelectModeAssignment) return;
                              if (e.target.tagName === "INPUT") return;
                              toggleGroupSelectItemAssignment(item.id);
                            };
                            const renderAssignmentItemRow = (item, idx, { showMoveButtons, onMoveUp, onMoveDown, moveUpDisabled, moveDownDisabled }) => (
                              <div
                                key={item.id}
                                className={`${styles.planItemRow}${groupSelectModeAssignment ? ` ${styles.planItemRowSelectable}` : ""}${groupSelectedIdsAssignment.includes(item.id) ? ` ${styles.planItemRowSelected}` : ""}`}
                                onClick={(e) => handleAssignmentRowClick(item, e)}
                              >
                                {groupSelectModeAssignment && (
                                  <input
                                    type="checkbox"
                                    className={styles.studentCheckbox}
                                    checked={groupSelectedIdsAssignment.includes(item.id)}
                                    onChange={() => toggleGroupSelectItemAssignment(item.id)}
                                    aria-label={`Selecionar ${item.exercise_item?.name || "exercício"}`}
                                  />
                                )}
                                <div className={styles.planItemRowOrder}>{idx + 1}</div>

                                <div className={styles.planItemRowMain}>
                                  <div className={styles.planItemTitle}>
                                    {item.exercise_item?.name || `Item ${item.id}`}
                                    {item.has_custom_demo && item.demo_source === "student" && (
                                      <span className={styles.customDemoBadge} data-tooltip="Vídeo de demonstração personalizado deste aluno">
                                        <FontAwesomeIcon icon={faVideo} /> vídeo do aluno
                                      </span>
                                    )}
                                    {item.has_custom_demo && item.demo_source === "professor" && (
                                      <span className={styles.customDemoBadge} data-tooltip="Vídeo próprio definido pelo professor - vale pra todos os alunos dele sem vídeo específico">
                                        <FontAwesomeIcon icon={faVideo} /> vídeo do professor
                                      </span>
                                    )}
                                  </div>
                                  <div className={styles.planItemMeta}>
                                    {item.category?.name && <Badge tone="default">{item.category.name}</Badge>}
                                    <span>
                                      {[
                                        item.sets_planned ? `${item.sets_planned}x` : null,
                                        item.reps_planned || null,
                                        item.weight_planned ? `${item.weight_planned}kg` : null,
                                        item.duration_planned ? `${item.duration_planned}min` : null,
                                        item.rest_seconds ? `${item.rest_seconds}s descanso` : null,
                                      ]
                                        .filter(Boolean)
                                        .join(" • ")}
                                    </span>
                                  </div>
                                </div>

                                {!groupSelectModeAssignment && (
                                  <div className={styles.planItemRowActions}>
                                    {showMoveButtons && (
                                      // Padronizado pro mesmo botão/tamanho usado no editor de
                                      // template e nos botões de mover o GRUPO aqui mesmo
                                      // (achado #3 da auditoria UX — .orderBtn de 26x22px
                                      // convivia com .wamBtn.smallGhost pra mover o mesmo tipo
                                      // de coisa na mesma lista).
                                      <>
                                        <button type="button" className={`${styles.wamBtn} ${styles.smallGhost}`} title="Mover para cima" onClick={onMoveUp} disabled={saving || moveUpDisabled}>↑</button>
                                        <button type="button" className={`${styles.wamBtn} ${styles.smallGhost}`} title="Mover para baixo" onClick={onMoveDown} disabled={saving || moveDownDisabled}>↓</button>
                                      </>
                                    )}
                                    <button
                                      type="button"
                                      className={`${styles.wamBtn} ${styles.smallGhost}`}
                                      onClick={() => openAssignmentItemEditor(item)}
                                    >
                                      Ajustar para o aluno
                                    </button>
                                    {(!item.workout_plan_item_id || item.workout_plan_item_id === null) ? (
                                      <button
                                        type="button"
                                        className={`${styles.wamBtn} ${styles.smallDanger}`}
                                        onClick={() => confirmRemoveAnonAssignmentItem(item.id)}
                                        disabled={saving}
                                      >
                                        Remover
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className={`${styles.wamBtn} ${styles.smallDanger}`}
                                        onClick={() => {
                                          setConfirmMessage('Deseja remover este exercício do treino padrão apenas deste vínculo?');
                                          setConfirmLabel('Remover do vínculo');
                                          confirmActionRef.current = async () => {
                                            resetFeedback();
                                            setSaving(true);
                                            try {
                                              const updated = (await api.post(`/user-workout-plans/${selectedStudentAssignmentId}/items/by-plan/${item.workout_plan_item_id}/hide`)).data;
                                              setStudentAssignments((prev) => prev.map((a) => (a.id === updated.id ? updated : a)));
                                              toast.success('Exercício removido do vínculo.');
                                            } catch (err) {
                                              toast.error(err.response?.data?.detail || err.message || 'Erro ao remover do vínculo.');
                                            } finally {
                                              setSaving(false);
                                            }
                                          };
                                          setShowConfirm(true);
                                        }}
                                        disabled={saving}
                                      >
                                        Remover do vínculo
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            );

                            const sortedItems2 = [...(selectedStudentAssignment.items || [])].sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0));
                            const blocks2 = buildItemBlocks(sortedItems2);
                            let runningIdx = 0;
                            return blocks2.map((block, blockIdx, blocksArr) => {
                              if (block.kind === "group") {
                                const startIdx = runningIdx;
                                runningIdx += block.items.length;
                                return (
                                  <div className={styles.groupWrapper} key={`agroup-${block.groupId}`}>
                                    <div className={styles.groupWrapperHeader}>
                                      <span className={styles.groupWrapperLabel}>
                                        <FontAwesomeIcon icon={faLink} />
                                        {groupLabel(block.items)} · sem descanso entre os exercícios
                                      </span>
                                      {!groupSelectModeAssignment && (
                                        <div className={styles.groupWrapperActions}>
                                          <button
                                            type="button"
                                            className={`${styles.wamBtn} ${styles.smallGhost}`}
                                            title="Mover grupo para cima"
                                            onClick={() => handleMoveAssignmentBlock(block, -1)}
                                            disabled={saving || blockIdx === 0}
                                          >
                                            ↑
                                          </button>
                                          <button
                                            type="button"
                                            className={`${styles.wamBtn} ${styles.smallGhost}`}
                                            title="Mover grupo para baixo"
                                            onClick={() => handleMoveAssignmentBlock(block, 1)}
                                            disabled={saving || blockIdx === blocksArr.length - 1}
                                          >
                                            ↓
                                          </button>
                                          <button
                                            type="button"
                                            className={`${styles.wamBtn} ${styles.smallGhost}`}
                                            onClick={() => handleUngroupAssignmentBlock(block.groupId)}
                                          >
                                            <FontAwesomeIcon icon={faLinkSlash} /> Desagrupar
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                    {block.items.map((item, i) =>
                                      renderAssignmentItemRow(item, startIdx + i, { showMoveButtons: false })
                                    )}
                                  </div>
                                );
                              }
                              const idx = runningIdx;
                              runningIdx += 1;
                              return renderAssignmentItemRow(block.item, idx, {
                                showMoveButtons: true,
                                onMoveUp: () => handleMoveAssignmentBlock(block, -1),
                                onMoveDown: () => handleMoveAssignmentBlock(block, 1),
                                moveUpDisabled: blockIdx === 0,
                                moveDownDisabled: blockIdx === blocksArr.length - 1,
                              });
                            });
                          })()}

                          {(() => {
                            const planItems = selectedStudentAssignment.plan_items || [];
                            const visibleIds = new Set((selectedStudentAssignment.items || [])
                              .map((it) => it.workout_plan_item_id)
                              .filter((v) => v != null));
                            const hiddenPlanItems = planItems.filter((pi) => !visibleIds.has(pi.id));
                            if (!hiddenPlanItems.length) return null;
                            return (
                              <div className={styles.planItemRow}>
                                <div className={styles.planItemRowMain}>
                                  <div className={styles.planItemTitle}>Itens ocultos no vínculo</div>
                                  <div className={styles.planItemMeta}><span>Restaure itens do treino padrão</span></div>
                                  <div className={styles.simpleList}>
                                    {hiddenPlanItems.map((pi) => (
                                      <div key={pi.id} className={styles.simpleRow}>
                                        <div className={styles.simpleRowMain}>
                                          <strong>{pi.exercise_item?.name || `Item #${pi.id}`}</strong>
                                        </div>
                                        <div className={styles.simpleRowActions}>
                                          <button
                                            type="button"
                                            className={`${styles.wamBtn} ${styles.smallGhost}`}
                                            onClick={() => confirmRestorePlanItem(pi.id)}
                                            disabled={saving}
                                          >
                                            Restaurar no vínculo
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
  );
}
